<template>
  <v-card class="pa-4" elevation="3" style="max-height: 80vh; overflow-y: auto;">
    <v-card-title class="text-h5 font-weight-bold mb-4">
      <v-icon left color="primary">mdi-tune</v-icon>
      Editar Valores de Alarmas
    </v-card-title>

    <v-container fluid>
      <v-row
        v-for="(item, index) in variables"
        v-if="item.active"
        :key="item.address"
        class="mb-3"
        align="center"
      >
      <v-col cols="12" md="8" class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="font-weight-medium">
              {{ item.label }}
            </span>
          </template>
          <span>{{ item.label }}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="item.anular">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="red"
              class="ml-2"
              small
            >
              mdi-information
            </v-icon>
          </template>
          <span>⚠️ Esta alarma está deshabilitada</span>
        </v-tooltip>
      </v-col>


        <v-col cols="12" md="4" class="d-flex justify-end">
          <v-btn
            color="blue"
            @click="abrirDialog(item)"
            class="mr-2"
            outlined
            small
          >
            <v-icon left>mdi-pencil</v-icon> Editar
          </v-btn>
          <!-- <v-btn
            v-else
            color="green"
            @click="guardarValor(index)"
            outlined
            small
          >
            <v-icon left>mdi-content-save</v-icon> Guardar
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" max-width="700px">
      <v-card v-if="selectedItem">
        <!-- Título -->
        <v-card-title class="text-h6 font-weight-bold">
          {{ selectedItem.label }}
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <!-- Temperatura actual -->
            <v-row dense align="center" class="py-0">
              <v-col cols="6" class="font-weight-medium py-0">Temperatura act.:</v-col>
              <v-col cols="6" class="py-0">
                <v-chip color="grey lighten-3" text-color="black" class="w-100 justify-center">
                  {{ selectedItem.value }} °C
                  <v-icon end small>mdi-lock</v-icon>
                </v-chip>
              </v-col>
            </v-row>

            <!-- Valor editable -->
            <v-row dense align="center" class="py-0">
              <v-col cols="6" class="font-weight-medium py-0">
                Valor de alarma por temperatura alta:
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="selectedItem.mod_value"
                  dense
                  outlined
                  hide-details
                  type="number"
                  suffix="°C"
                  @blur="guardarParametro()"
                />
              </v-col>
            </v-row>

            <!-- Selector anular -->
            <v-row dense align="center" class="py-0" v-if="selectedItem.anular_address" >
              <v-col cols="6" class="font-weight-medium py-0">Deshabilitar canal:</v-col>
              <v-col cols="6" class="d-flex align-center py-0">
                <v-switch
                  v-model="selectedItem.anular"
                  inset
                  @click="anular()"
                  :label="selectedItem.anular ? 'On' : 'Off'"
                />
              </v-col>
            </v-row>

            <!-- Valor variación brusca -->
            <v-row dense align="center" class="py-0">
              <v-col cols="6" class="font-weight-medium py-0">Valor para Variación brusca:</v-col>
              <v-col cols="6" class="py-0">
                <v-chip color="grey lighten-3" text-color="black" class="w-100 justify-center">
                  {{ variables[0]?.value }} °C
                  <v-icon end small>mdi-lock</v-icon>
                </v-chip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarDialog">Cerrar</v-btn>
          <v-btn color="green" text @click="guardarValor()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    variables: Array,
    PLC: String,
  },
  data() {
    return {
      selectedItem: null,
      dialog: false,
    };
  },
  // mounted() {
    // Inicializa valores desde params si vienen
    // this.variables.forEach((item, index) => {
    //   if (this.params && this.params[index] !== undefined) {
    //     item.value = this.params[index];
    //     item.anular = this.anuladas[index] == 0 ? false : true;
    //   }
    // });
  // },
  // watch: {
  //   params(newParams) {
  //     this.variables.forEach((item, index) => {
  //       if (newParams[index] !== undefined) {
  //         item.value = newParams[index];
  //       }
  //     });
  //   },
  //   anuladas(newParams){
  //     this.variables.forEach((item, index) => {
  //       if (newParams[index] !== undefined) {
  //         item.anular = newParams[index];
  //       }
  //     });
  //   }
  // },
  methods: {
    ...mapActions("nodered", ["doPublish"]),

    // guardarValor(index) {
    //   const item = this.variables[index];
    //   this.setRunOrderValue(item.value, item.address);
    //   item.editando = false;
    //   // console.log(`Guardado ${item.label} = ${item.value} en ${item.address}`);
    // },

    setRunOrderValue(value, address, topic) {
      this.doPublish({
        topic: topic,
        message: { address, value },
      });
    },

    abrirDialog(item) {
      this.selectedItem = {...item, mod_value: item.value};
      this.dialog = true;
    },
    guardarParametro(){
      this.setRunOrderValue(parseInt(this.selectedItem.mod_value), this.selectedItem.address, `PLC${this.PLC}WREAL`);
      this.$emit("actualizar-variables");
    },
    guardarValor(){
      // console.log(this.selectedItem);
      this.setRunOrderValue(parseInt(this.selectedItem.mod_value), this.selectedItem.address, `PLC${this.PLC}WREAL`);
      this.dialog = false;
      this.selectedItem = null;
      this.$emit("actualizar-variables");
    },
    cerrarDialog(){
      if (this.selectedItem.value !== this.selectedItem.mod_value){
        this.setRunOrderValue(parseInt(this.selectedItem.value), this.selectedItem.address, `PLC${this.PLC}WREAL`);
        this.$emit("actualizar-variables");
      }
      this.dialog = false;
    },
    anular(){
      this.setRunOrderValue(this.selectedItem.anular, this.selectedItem.anular_address, `PLC${this.PLC}WBOOL`);
      this.$emit("actualizar-variables");
    }
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}

.v-text-field input {
  text-align: right;
}

.font-weight-medium {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-tooltip {
  max-width: 400px;
}

.v-btn {
  min-width: 90px;
}
</style>
